import CommandHandler from 'diagram-js/lib/command/CommandHandler';
import {ModelingUtil} from '@ispm/shared/bpmn-io/modeling-util';
import {PathwaysModeling} from '@ispm-client/modules/bpmn-modeler/bpmn/commands/pathways-modeling';
import EventBus from 'diagram-js/lib/core/EventBus';
import {isEmpty} from 'lodash';
import {FloatingNodesService} from "@ispm/shared/bpmn-io/services/floating-nodes-service";
import {connection, exclusiveGatewayType} from '@ispm-shared/modules/bpmn/diagram-element-terms';
import {EventType} from "@ispm/shared/bpmn-io/bpmn-js";
import {selectNodeCreationInfoById} from "@ispm-client/modules/bpmn-modeler/store/selectors";
import {take} from "rxjs/operators";
import {State} from "@ispm-client/modules/bpmn-modeler/store/state";
import {Store, select} from "@ngrx/store";

export class RemoveConnectionHandler implements CommandHandler {

  constructor(protected pathwaysModeling: PathwaysModeling, protected eventBus: EventBus, private floatingNodesService: FloatingNodesService, private store$: Store<State>) {
  }

  preExecute(context) {
    const element = context.element;
    let elementsToRemove = [element];
    element.preDeletionTrackingChange = true;
    // test type of this element
    const elementType = ModelingUtil.getElementType(element);
    if (elementType === connection) {
      // check if its last connected link
      const gateway = this.checkIfItsLastConnectedLink(element);
      if (gateway) {
        elementsToRemove.push(gateway);
      }
    }
    context.elementsToRemove = elementsToRemove;
    if (!isEmpty(elementsToRemove) && !context.onSubmitForApproval) {
      this.floatingNodesService.addFloatedElementsWhenRemovingConnection(context.element);
    }
  }

  postExecute(context): any {
    const elementsToRemove = context.elementsToRemove;
    if (!isEmpty(elementsToRemove) && context.onSubmitForApproval !== true) {
          const connectionToRemove = elementsToRemove.find((element) => ModelingUtil.getElementType(element) === connection);
          this.updateDirectTreeAfterRemovingConnection(connectionToRemove);
          this.updateParentCondition(connectionToRemove);
          this.pathwaysModeling.removeElements(elementsToRemove);
    }
  }

  protected updateDirectTreeAfterRemovingConnection(connectionToRemove) {
    const targets = ModelingUtil.getElementType(connectionToRemove.target) === exclusiveGatewayType ? ModelingUtil.getDirectTreeChildrenNodes(connectionToRemove.target) : [connectionToRemove.target];
    this.eventBus.fire(EventType.NODE_UPDATED, {targets});
  }

  checkIfItsLastConnectedLink(element) {
    let suspectedGateway;
    if (ModelingUtil.isGateway(element.source)) {
      suspectedGateway = element.source;
      if (ModelingUtil.getNodeIncomingConnections(suspectedGateway).length === 0) {
        return suspectedGateway;
      }
    }
    if (ModelingUtil.isGateway(element.target)) {
      suspectedGateway = element.target;
      if (ModelingUtil.getNodeOutgoingConnections(suspectedGateway).length === 0) {
        return suspectedGateway;
      }
    }
    return undefined;
  }

  protected updateParentCondition(connectionToRemove){
    this.store$.pipe(select(selectNodeCreationInfoById([connectionToRemove.target.id])),
      take(1)).subscribe(nodes => {
      if (nodes && nodes[0]) {
        if (nodes && nodes.length > 0) {
          const nodeCreationResult = nodes[0] ? nodes[0].data : undefined;
          const nodeType = ModelingUtil.getNodeType(connectionToRemove.target);
          const ignoreTrackingChange = false;
          if (nodeCreationResult) {
            this.pathwaysModeling.resetNodeData(connectionToRemove.target, nodeCreationResult, nodeType, ignoreTrackingChange);
          }
        }}}).unsubscribe();
  }
}
